import { Action, createAction, handleActions } from 'redux-actions'
import { takeLatest } from 'redux-saga/effects'
import { oc } from 'ts-optchain'

import {
  fetchScheduleHistoryList,
  IFindScheduledTransferHistoriesResponse,
} from '@/api/SchedulePaymentApi'
import { IPageInfoRequest, IPageInfoResponse } from '@/domains/CommonDomain'
import {
  EmptyScheduledTransferHistory,
  IScheduledTransferHistory,
} from '@/domains/SchedulePaymentDomain'
import { IRootState } from '@/modules'
import { createFetchAction, createSaga } from '@/utils/actionUtils'
import { apiFailureReducer, increasePage, reset } from '@/utils/reducerUtils'

interface IScheduledTransferHistories {
  scheduledTransferHistories: IScheduledTransferHistory[]
  pageInfo: IPageInfoResponse
}

export type ISchedulePaymentHistoryState = Readonly<IScheduledTransferHistories>

export const SCHEDULE_PAYMENT_HISTORY = 'SchedulePaymentHistory'

const initialState: ISchedulePaymentHistoryState = {
  scheduledTransferHistories: [],
  pageInfo: {
    curPage: 1,
    totPage: 10,
  },
}

const INCREASE_PAGE = `${SCHEDULE_PAYMENT_HISTORY}/increasePage`
const RESET_STATE = `${SCHEDULE_PAYMENT_HISTORY}/resetState`

export const schedulePaymentHistoryActions = {
  increasePage: createAction(INCREASE_PAGE),
  resetState: createAction(RESET_STATE),
}
export const schedulePaymentHistoryAsync = createFetchAction<IPageInfoRequest>(
  SCHEDULE_PAYMENT_HISTORY,
)

export const reducer = {
  [schedulePaymentHistoryAsync.SUCCESS]: (
    state: ISchedulePaymentHistoryState,
    action: Action<IFindScheduledTransferHistoriesResponse>,
  ) => {
    const { scheduledTransferHistories = [], pageInfo = state.pageInfo } = action.payload

    return {
      ...state,
      pageInfo,
      scheduledTransferHistories: state.scheduledTransferHistories.concat(
        scheduledTransferHistories,
      ),
    }
  },
  [schedulePaymentHistoryAsync.FAILURE]: apiFailureReducer,
  [INCREASE_PAGE]: increasePage,
  [RESET_STATE]: (state: ISchedulePaymentHistoryState) => reset(state, initialState),
}

export const schedulePaymentHistorySelector = {
  scheduleHistories: (state: IRootState) =>
    oc(state[SCHEDULE_PAYMENT_HISTORY]).scheduledTransferHistories([]),
  scheduledTransferHistory: (state: IRootState, refNo: string) =>
    oc(state[SCHEDULE_PAYMENT_HISTORY])
      .scheduledTransferHistories([])
      .find((item: IScheduledTransferHistory) => item.refNo === refNo) ||
    EmptyScheduledTransferHistory,
  scheduleHistoriesPageInfo: (state: IRootState) => ({
    curPage: oc(state[SCHEDULE_PAYMENT_HISTORY]).pageInfo.curPage(initialState.pageInfo.curPage),
    totPage: oc(state[SCHEDULE_PAYMENT_HISTORY]).pageInfo.totPage(initialState.pageInfo.totPage),
  }),
}

export const fetchScheduleTransferHistories = createSaga<IPageInfoRequest>(
  schedulePaymentHistoryAsync,
  fetchScheduleHistoryList,
)

export const schedulePaymentHistoryReducer = handleActions(reducer, initialState)
export const schedulePaymentHistorySaga = [
  takeLatest(schedulePaymentHistoryAsync.FETCH, fetchScheduleTransferHistories),
]
